import { render, staticRenderFns } from "./xeSelfRateNewSetting.vue?vue&type=template&id=b5859e1a"
import script from "./xeSelfRateNewSetting.vue?vue&type=script&lang=js"
export * from "./xeSelfRateNewSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports